import React from "react";
import HeroImg from "../../../assets/website/img/hero-bg.jpg";
import Typed from "typed.js";

import { Link } from "react-router-dom";
function Hero() {
  // Create reference to store the DOM element containing the animation
  const el = React.useRef(null);
  React.useEffect(() => {
    const typed = new Typed(el.current, {
      strings: ["Graphic Designer", "Developer", "Freelancer"],
      typeSpeed: 100,
      backSpeed: 50,
      loop: true,
    });

    return () => {
      // Destroy Typed instance during cleanup to stop animation
      typed.destroy();
    };
  }, []);

  return (
    <>
      <section id="hero" className="hero section dark-background">
        <img src={HeroImg} alt="" />
        <div className="container">
          <h2 style={{ color: "white" }}>Mohammad Snoabr</h2>
          <p>
            I'm&nbsp;
            <span
              className="typed text-white"
              data-typed-items="Designer, Developer, Freelancer"
            >
              <span ref={el} />
            </span>
            <span className="typed-cursor typed-cursor--blink" />
          </p>
          <div className="social-links">
            <Link to="https://www.facebook.com/mohammad.sn.31" target="_blank">
              <i className="bi bi-facebook" />
            </Link>
            <Link to="https://wa.me/+905389587088" target="_blank">
              <i className="bi bi-whatsapp" />
            </Link>
            <Link to="https://x.com/mohammadsn3" target="_blank">
              <i className="bi bi-twitter-x" />
            </Link>
            <Link to="https://www.instagram.com/mohammad.sn98/" target="_blank">
              <i className="bi bi-instagram" />
            </Link>
            <Link to="https://www.youtube.com/@mohammadsn932" target="_blank">
              <i className="bi bi-youtube" />
            </Link>
            <Link
              to="https://www.linkedin.com/in/mohamad-snobar-3710b219a/"
              target="_blank"
            >
              <i className="bi bi-linkedin" />
            </Link>
            <Link to="https://www.behance.net/mohammadsnGD" target="_blank">
              <i className="bi bi-behance" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default Hero;
